<div [appStoryblok]="_editable" *ngIf="currentMessage" [@fade]>
  <ndc-dynamic
    *ngIf="components"
    [ndcDynamicComponent]="components[currentMessage.component]"
    [ndcDynamicInputs]="currentMessage"
  >
  </ndc-dynamic>
</div>
